<video #localVideo playsinline autoplay [muted]="true"></video>
